var ua = window.navigator.userAgent;
var msie = ua.indexOf('MSIE ');
var trident = ua.indexOf('Trident/');
if(msie > 0 || trident > 0){
   alert("Internet Explorer není podporován prohlížeč, prosím využijte moderní alternativu, Google Chrome, atd. Děkujeme za pochopení.");
}

$('<tr><th>Kód produktu</th><td class="kodprodukt"></td></tr>').appendTo('.extended-description table.detail-parameters')
$('.p-detail-inner-header .p-code').appendTo('.kodprodukt');

$(".slider-wrapper").addClass("filter-section");

 $(document).bind('ready ajaxComplete', function(){
 var selector = '.filter-section ';
$(selector).on('click', function(){
    $(selector).removeClass('mhfilteropen');
    $(this).toggleClass('mhfilteropen');
});



$('.filter-section .filter-label.active').closest('.filter-section').addClass('openFilter');
});

if($('aside.sidebar').length){
  $('#categories .categories>div.topic').each(function(){
    var findtitle = $(this).find('a').text();
    var findalt = $(this).find('a').text();
    var findtitle = findtitle.normalize('NFD').replace(/[^\w]/g, '').toLowerCase();
    $(this).addClass(findtitle);
    $(this).find('a').prepend('<div style="-webkit-mask: url(/user/documents/upload/sidebar_kategorie/'+findtitle+'.svg) center center no-repeat;mask: url(/user/documents/upload/sidebar_kategorie/'+findtitle+'.svg) center center no-repeat;    width: 32px;height: 32px;-webkit-mask-size: 25px;mask-size: 25px;background-color: #9b3181;">')
  })
};
$(document).ready(function(){
$('#categories .categories .topic a').attr('style', 'padding-left:10px;')
});
shoptet.cookie.create('debugTimestamp', 1, {days: 1});
$(window).on('load', function() {
  $('.fvsctp-img img').each(function(){

    var findsrc = $(this).attr('src');

    var findsrcnew = findsrc.replace('detail', 'orig');
    $(this).attr("src", findsrcnew);  
  }); 
});
if($('.products').length){
    function mhproduct(){
        $('.product').each(function(){
            var havsleva = $(this).find('.flags-extra .flag-discount');
            var findpuvodnice = $(this).find('.flag-discount .price-standard');
            var findcena = $(this).find('.prices');
            
            if($(havsleva).length){
                $(findcena).addClass('discount')
                $(findcena).prepend(findpuvodnice);
            }
        });
        $(".products .product .flag-discount").each(function() {
            $(this).html(function(){
                return $(this).html().replace("od", "");
            })
        });

    };
    mhproduct();
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        mhproduct();
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        mhproduct();
    });
}

if($('.appended-category').length){
  $('.appended-category').each(function(){
    var findtitle = $(this).find('>a').text();
    var findalt = $(this).find('>a').text();
    var findtitle = findtitle.normalize('NFD').replace(/[^\w]/g, '').toLowerCase();
    $(this).addClass(findtitle);
    $(this).find('>a').prepend('<div style="-webkit-mask: url(/user/documents/upload/sidebar_kategorie/'+findtitle+'.svg) center center no-repeat;mask: url(/user/documents/upload/sidebar_kategorie/'+findtitle+'.svg) center center no-repeat;    width: 32px;height: 32px;-webkit-mask-size: 25px;mask-size: 25px;background-color: #9b3181;">')
  })
};



if($('.in-index').length){
    $('.homepage-group-title:contains("Novinky")+.products-block').after('<div class="text-center mhbutton"><a href="/novinky" class="btn btn-default">Další novinky</a></div>')
    $('.homepage-group-title:contains("Dětské povlečení - NOVINKY")+.products-block').after('<div class="text-center mhbutton"><a href="https://www.povlecemevas.cz/detsky-pokoj/?dd=2/" class="btn btn-default">Další povlečení</a></div>')
    $('.homepage-group-title:contains("Výprodej")+.products-block').after('<div class="text-center mhbutton"><a href="/vyprodej/" class="btn btn-default">Výprodej</a></div>')

}

var odkazypata = '<section class="odkazy"><div class="container"><div class="row"><div class="col-sm-12 text-center"><img src="https://www.povlecemevas.cz/user/documents/upload/heureka.png"><img src="https://www.povlecemevas.cz/user/documents/upload/posta.png"><img src="https://www.povlecemevas.cz/user/documents/upload/textil.png"><img src="https://www.povlecemevas.cz/user/documents/upload/tzu.png"></div></div></div></section>';
$(odkazypata).insertAfter('.in-index div.content-wrapper-in');

$('<section class="blog"><div class="container"><h3 class="text-center">Z blogu</h3><div class="semblog"></div><div class="text-center"><a href="/blog/" class="btn btn-nexttext">Další články</a></div></div></section>').insertAfter('.in-index div.content-wrapper-in');
$('.semblog').load('/blog/ #newsWrapper .news-item:nth-child(-n+3)');
$('footer#footer div.extended h4').text('Odebírat novinky');
$('<p>Chcete dostávat novinky z našeho e-shopu na váš e-mail?</p>').insertBefore('footer#footer div.extended form');
$('#formNewsletterWidget button[type="submit"] span').removeClass('sr-only');
$('.container.footer-bottom').removeClass('container').wrapInner('<div class="container"></div>');
$('span#signature').html('Nakódoval <a href="https://www.eshopguru.cz" target="_blank">EshopGuru</a> | Běžíme na <a href="https://www.shoptet.cz/?utm_source=footer&amp;utm_medium=link&amp;utm_campaign=create_by_shoptet" title="Vytvořil Shoptet" class="title" target="_blank">Shoptet</a>');
//$('.homepage-box.welcome-wrapper').insertBefore('.blog');
//$('<div class="fotodilny"><img src="/user/documents/upload/sablona-nemazat/dilnapovleceme.png" alt="Foto dílny"></div>').insertAfter('.welcome-wrapper .welcome');
$('<a href="/registrace/" class="registrace"><span class="flaticon-lock">Registrace</span></a>').insertBefore('a.login');
$('.top-navigation-tools .top-nav-button-login span' ).addClass( 'flaticon-male');
$('.semblog .news-item:first-child').each(function(){
  var odkaz= $(this).find('.text');
  if( odkaz.length > 0 ) {
     $(this).find('a.title').clone().appendTo(odkaz).text('Přečíst celé').addClass('btn-arrow').removeClass('title');
  }
});
$('footer#footer div.extended').insertBefore('footer#footer').addClass('section-subscribe');


$('.search .form-control').attr('placeholder', 'Jaký produkt hledáte…?');
$('.in-index .banners-content.body-banners').removeClass('row');
//$('<div class="text-center mhbutton"><a href="https://www.povlecemevas.cz/novinky/" class="btn btn-nexttext">Další produkty</a></div>').appendTo('.in-index main#content');
$('.subscribe-form .form-control').attr('placeholder', 'Váš email');
$('.subscribe-form .consents.consents-first label.whole-width').html('Přihlášením souhlasím se <a href="/podminky-ochrany-osobnich-udaju/" target="_blank" rel="noopener noreferrer">zpracováním osobních údajů.</a>')
$('.header-top .cart-count .cart-price.visible-lg-inline-block').removeClass('visible-lg-inline-block');
$('.breadcrumbs-wrapper').prependTo('#content').removeClass('container');
$('.category-perex').insertAfter('.category-title');
$('.type-category .box.box-sm.box-filters').insertBefore('.type-category #category-header');
//PHOTOsmart-1989??$('.pagination-wrapper .pagination-loader').insertAfter('.pagination-wrapper');
//$('.pagination-loader .btn').addClass('btn-nexttext').removeClass('btn-default');
$('.extended-description').prependTo('.p-info-wrapper');
$('.p-info-wrapper .chevron-after').prependTo('.p-info-wrapper');
$('.p-short-description').prependTo('.p-info-wrapper');
$('.p-detail-info').prependTo('.p-info-wrapper');
$('.p-info-wrapper .add-to-cart').wrapAll('<div class="add-to-cart-wrapper"></div>');
$('.p-info-wrapper .p-final-price-wrapper').prependTo('.p-info-wrapper .add-to-cart-wrapper');
$('.p-info-wrapper .chevron-after').text('Celý popis');
$('<span class="ks">ks</span>').insertAfter('.add-to-cart .quantity');
$('.shp-tabs-wrapper').insertAfter('.p-detail-inner');
$('#filters .to').insertAfter('#filters .slider-content');
$('#filters .filter-section-default').appendTo('#filters .slider-wrapper');
if($(".type-product").length) {
   var pkUrl = window.location.pathname;
   var pkName = $('h1').text();
   var pkPrice = $('.price-final span').last().text();
   var pkImg = $(".p-image a img").attr("src");
   var pkParametr = $('.extended-description .detail-parameters tr:contains("Perex:") td').html();
   var pkArrIn = [pkUrl, pkName, pkImg, pkPrice, pkParametr];
   if(!JSON.parse(localStorage.getItem("url"))) {
       var pkArr = [pkArrIn];
       localStorage.setItem("url", JSON.stringify(pkArr));
   } else {
       var pkArr = JSON.parse(localStorage.getItem("url"));
       for (var a = 0; a < pkArr.length; a++) {
           if(pkArr[a].includes(pkUrl)) {
               pkArr.splice(a, 1);
           }
       }
       pkArr.unshift(pkArrIn);
       if(pkArr.length > 3) {
           pkArr.pop();
       }
       localStorage.setItem("url", JSON.stringify(pkArr));
   }
}
if(JSON.parse(localStorage.getItem("url"))) {
   var pkArr = JSON.parse(localStorage.getItem("url"));
} else {
   pkArr = "";

}
if(pkArr.length) {
   $(".extended").before('<div id="pkRecentlyViewed" class="container pkRecentlyViewed">'+
                                   '<div class="h4 homepage-group-title text-center">Naposledy jste prohlíželi</div>'+
                                   '<div class="pkReViIn"></div>'+
                                '</div>');
   for (var i = 0; i < pkArr.length; i++) {
       $(".pkReViIn").append('<a class="pkReViInPr" href="' + pkArr[i][0] + '">'+
                               '<div class="pkReViInPrImg"><img src="' + pkArr[i][2] + '"></div>'+
                               '<div class="pkReViInPrName">' + pkArr[i][1] + '</div>'+
                              // '<div class="pkReViInPrattr">' + pkArr[i][4] + '</div>'+
                               '<div class="pkReViInPrPrice">' + pkArr[i][3] + '</div>'+
                               
                             '</a>')
   }
 

};



$( document ).ajaxComplete(function(  ) {
  
   $('.semblog .news-item:first-child').each(function(){
      var odkaz= $(this).find('.text');
      if( odkaz.length > 0 ) {
         $(this).find('a.title').clone().appendTo(odkaz).text('Přečíst celé').addClass('btn-arrow').removeClass('title');
      }
   });
   $('.type-category .box.box-sm.box-filters').insertBefore('.type-category #category-header');
   $('#filters .to').insertAfter('#filters .slider-content');
   $('#filters .filter-section-default').appendTo('#filters .slider-wrapper');
   $('.pagination-wrapper .pagination-loader').insertAfter('.pagination-wrapper');

});

$('.subcategories.with-image>li').removeClass('col-sm-4').addClass('col-sm-6');




if ($(".variant-list select.hidden-split-parameter").length) {
$(".variant-list select.hidden-split-parameter").each(function(option_index){
    so_classes = $(this).attr("class");
    so_value = $(this).html();
    so_attr1 = $(this).attr("data-parameter-id");
    so_attr2 = $(this).attr("data-parameter-name");
    so_attr3 = $(this).attr("id");
    so_attr4 = $(this).attr("name");
    so_newLabel = $("<div></div>").html(so_value);
    $(so_newLabel).attr("class",so_classes);
    $(so_newLabel).attr("data-parameter-id",so_attr1);
    $(so_newLabel).attr("data-parameter-name",so_attr2);
    $(so_newLabel).attr("id",so_attr3);
    $(so_newLabel).attr("name",so_attr4);
    $(so_newLabel).attr("value",option_index);
    $(this).replaceWith(so_newLabel);
});
if ($( ".variant-list:first-of-type .hidden-split-parameter option").length == 1) {
    $( ".variant-list:first-of-type .hidden-split-parameter").prepend("<option></option>"); 
    }
if ($( ".variant-list:nth-of-type(2) .hidden-split-parameter option").length == 1) {
    $( ".variant-list:nth-of-type(2) .hidden-split-parameter").prepend("<option></option>");
    }
if ($( ".variant-list:nth-of-type(3) .hidden-split-parameter option").length == 1) {
    $( ".variant-list:nth-of-type(3) .hidden-split-parameter").prepend("<option></option>");
}
$( ".variant-list .hidden-split-parameter option:first-of-type" ).wrap( "<span></span>" );
$( ".variant-list:first-of-type .hidden-split-parameter span option" ).replaceWith('<input type="radio" value name class="variant-default" checked="checked">');
$( ".variant-list:nth-of-type(2) .hidden-split-parameter span option" ).replaceWith('<input type="radio" value name class="variant-default" checked="checked">');
$( ".variant-list:nth-of-type(3) .hidden-split-parameter span option" ).replaceWith('<input type="radio" value name class="variant-default" checked="checked">');
$( ".variant-list .hidden-split-parameter option:not(:first-child)" ).wrap( "<label class='advanced-parameter'></label>" );
$( ".variant-list .hidden-split-parameter label option").each(function(data_index){
    option_value = $(this).attr("value");
    option_html = $(this).html();
    option_select = $(this).attr("selected");
    option_name = $(this).parents(".hidden-split-parameter").attr("name");
    option_newLabel = $("<input>");
    option_newInDiv = $("<span class='parameter-value'></span>").html(option_html);
    option_newBeDiv = $('<span class="advanced-parameter-inner show-tooltip" title=""></span>').attr("data-original-title",option_html);
    option_newApSpan = $('<span class="pkVS"></span>').html(option_html);
    option_data_index = data_index + 1;
    $(option_newLabel).attr("value",option_value);
    $(option_newLabel).attr("name",option_name);
    $(option_newLabel).attr("selected",option_select);
    $(option_newLabel).attr("data-index",option_data_index);
    $(option_newLabel).attr("type","radio");
    $(this).parents(".hidden-split-parameter").children("span").children("input").attr("name",option_name);
    $(this).after(option_newInDiv);
    $(this).before(option_newBeDiv);
    $(this).parent("label").find(".advanced-parameter-inner").append(option_newApSpan);
    $(this).replaceWith(option_newLabel);
});
}
//Zakliknutí­m vybraných parametrů (při pře­chodu na produkt z odkazu)
$(window).on("load", function (){
    $( ".variant-list .hidden-split-parameter label input[selected]").each(function(){
        $(this).parent().children(".advanced-parameter-inner").click();
    })
})
//Zakliknutím samostatných parametrů
$(window).load(function(){
if ($( ".variant-list:first-of-type .hidden-split-parameter label").length == 1) {
$( ".variant-list:first-of-type .hidden-split-parameter .advanced-parameter .advanced-parameter-inner").click().addClass("yes-before");
$( ".variant-list:first-of-type").addClass("variant-selected");
}
if ($( ".variant-list:nth-of-type(2) .hidden-split-parameter label").length == 1) {
$( ".variant-list:nth-of-type(2) .hidden-split-parameter .advanced-parameter .advanced-parameter-inner").click().addClass("yes-before");
$( ".variant-list:nth-of-type(2)").addClass("variant-selected");
}
if ($( ".variant-list:nth-of-type(3) .hidden-split-parameter label").length == 1) {
$( ".variant-list:nth-of-type(3) .hidden-split-parameter .advanced-parameter .advanced-parameter-inner").click().addClass("yes-before");
$( ".variant-list:nth-of-type(3)").addClass("variant-selected");
}
})
//Označení­ parametrů s vlastní­mi obrázky/barvami
if ($(".hidden-split-parameter .advanced-parameter .advanced-parameter-inner img").length) {
$(".hidden-split-parameter .advanced-parameter .advanced-parameter-inner img").parents(".hidden-split-parameter").addClass("pkOwnPic");
}
if ($(".hidden-split-parameter .advanced-parameter .advanced-parameter-inner").filter("[style*='background-color:']").length) {
$(".hidden-split-parameter .advanced-parameter .advanced-parameter-inner").filter("[style*='background-color:']").parents(".hidden-split-parameter").addClass("pkOwnColor");
}
 
//Doplňování­ dostupnosti k poslední variantě
if ($(".type-product .variant-list").length == 1) {
if ($( ".variant-list .hidden-split-parameter label").length == 1) {
$( ".variant-list .hidden-split-parameter .advanced-parameter .advanced-parameter-inner").click();
$( ".variant-list").addClass("variant-selected");
$( ".variant-list .hidden-split-parameter .advanced-parameter-inner").addClass("yes-before");
}
$(".variant-list .hidden-split-parameter").addClass("pkParametr1");
$(".variant-list .hidden-split-parameter .advanced-parameter-inner").css("border-bottom-left-radius","0").css("border-bottom-right-radius","0");
$(".variant-list .hidden-split-parameter .advanced-parameter input").each(function(pk1index) {
$("body").addClass("pkVarSelected");
$(".variant-list .hidden-split-parameter .advanced-parameter input").removeAttr("id");
var pk1Num = pk1index + 1;
var pk1Num = '.variant-list .hidden-split-parameter .advanced-parameter:nth-child(' + pk1Num + ') input';
pk1Num = $(this).attr("id", "pk1Selected");
var pk1p1 = $(".pkParametr1").attr("data-parameter-id");
var pk1v1 = $("#pk1Selected").attr("value");
if ($( ".variant-list .hidden-split-parameter label").length == 1) {
    var Final1Variant = ".availability-value .availability-label";
} else {
    var Final1Variant = ".availability-value .parameter-dependent." + pk1p1 + "-" + pk1v1 + " .availability-label";
}
var pk1Var = pk1index + 1;
var pk1Var = "<div class='pkVar pkVariants" + pk1Var + "'></div>";
var pk1VarD = pk1index + 1;
var pk1VarD = ".pkVariants" + pk1VarD;
$(pk1VarD).remove();
$(this).parent().append(pk1Var);
$(Final1Variant).clone().appendTo(pk1VarD);
})}
if ($(".type-product .variant-list").length == 2 && $(".availability-value.variant-not-chosen-anchor span").length != 1) {
var fullClass2m = $(".availability-value .parameter-dependent:first-of-type").attr("class");
var fullClass2m = fullClass2m.split(' ');
var pk2Not1 = "noDisplay";
var pk2Not2 = "parameter-dependent";
if ($(".availability-value .parameter-dependent:first-of-type").attr("class").includes("no-display")) { 
    if (fullClass2m[0] == pk2Not1 || fullClass2m[0] == pk2Not2) {} else { var fullClass2 = fullClass2m[0]; }
    if (fullClass2m[1] == pk2Not1 || fullClass2m[1] == pk2Not2) {} else { var fullClass2 = fullClass2m[1]; }
    if (fullClass2m[2] == pk2Not1 || fullClass2m[2] == pk2Not2) {} else { var fullClass2 = fullClass2m[2]; }
} else {
    if (fullClass2m[0] == pk2Not2) {} else { var fullClass2 = fullClass2m[0]; }
    if (fullClass2m[1] == pk2Not2) {} else { var fullClass2 = fullClass2m[1]; }
}
var fullClass2 = fullClass2.split('-');
var firstClass2 = fullClass2[0];
var secondClass2 = fullClass2[2];
$(".variant-list:first-of-type").attr("id", "pkVarSelected");
$(".variant-list:first-of-type .hidden-split-parameter").addClass("pkParametr1");
$(".variant-list:nth-of-type(2) .hidden-split-parameter").addClass("pkParametr2");
document.getElementById("pkVarSelected").addEventListener("change", pk2Function);
function pk2Function() {
$(".pkParametr2 .advanced-parameter-inner").css("border-bottom-left-radius","0").css("border-bottom-right-radius","0");
$(".variant-list:nth-of-type(2) .hidden-split-parameter .advanced-parameter input").each(function(pk2index) {
$("body").addClass("pkVarSelected");
$(".variant-list:first-of-type .hidden-split-parameter .advanced-parameter input").removeAttr("id","pk1Selected");
$(".variant-list:first-of-type .advanced-parameter-inner.yes-before").parent("label").children("input").attr("id","pk1Selected");
$(".variant-list:nth-of-type(2) .hidden-split-parameter .advanced-parameter input").removeAttr("id");
var pk2Num = pk2index + 1;
var pk2Num = '.variant-list:nth-of-type(2) .hidden-split-parameter .advanced-parameter:nth-child(' + pk2Num + ') input';
pk2Num = $(this).attr("id", "pk2Selected");
var pk2p1 = $(".pkParametr1").attr("data-parameter-id");
var pk2v1 = $("#pk1Selected").attr("value");
var pk2p2 = $(".pkParametr2").attr("data-parameter-id");
var pk2v2 = $("#pk2Selected").attr("value");
if (pk2p1 == firstClass2) {
var pk2Final1 = pk2p1 + "-" + pk2v1;
}
if (pk2p1 == secondClass2) {
var pk2Final2 = pk2p1 + "-" + pk2v1;
}
if (pk2p2 == firstClass2) {
var pk2Final1 = pk2p2 + "-" + pk2v2;
}
if (pk2p2 == secondClass2) {
var pk2Final2 = pk2p2 + "-" + pk2v2;
}
var Final2Variant = ".availability-value .parameter-dependent." + pk2Final1 + "-" + pk2Final2 + " .availability-label";
var pk2Var = pk2index + 1;
var pk2Var = "<div class='pkVar pkVariants" + pk2Var + "'></div>";
var pk2VarD = pk2index + 1;
var pk2VarD = ".pkVariants" + pk2VarD;
$(pk2VarD).remove();
$(this).parent().append(pk2Var);
$(Final2Variant).clone().appendTo(pk2VarD);
})
$(".advanced-parameter").removeClass("pkVarNotExist");
if( $('.advanced-parameter .pkVar').is(':empty') ) {
    $(".advanced-parameter .pkVar:empty").parent().addClass("pkVarNotExist");
    $(".advanced-parameter .pkVar:empty").html("neexistuje").css("color","#920304").css("text-align","center");
}}}
if ($(".type-product .variant-list").length == 3 && $(".availability-value.variant-not-chosen-anchor span").length != 1){
var fullClass3m = $(".availability-value .parameter-dependent:first-of-type").attr("class");
var fullClass3m = fullClass3m.split(' ');
var pk3Not1 = "noDisplay";
var pk3Not2 = "parameter-dependent";
if ($(".availability-value .parameter-dependent:first-of-type").attr("class").includes("no-display")) { 
    if (fullClass3m[0] == pk3Not1 || fullClass3m[0] == pk3Not2) {} else { var fullClass3 = fullClass3m[0]; }
    if (fullClass3m[1] == pk3Not1 || fullClass3m[1] == pk3Not2) {} else { var fullClass3 = fullClass3m[1]; }
    if (fullClass3m[2] == pk3Not1 || fullClass3m[2] == pk3Not2) {} else { var fullClass3 = fullClass3m[2]; }
} else {
    if (fullClass3m[0] == pk3Not2) {} else { var fullClass3 = fullClass3m[0]; }
    if (fullClass3m[1] == pk3Not2) {} else { var fullClass3 = fullClass3m[1]; }
}
var fullClass3 = fullClass3.split('-');
var firstClass3 = fullClass3[0];
var secondClass3 = fullClass3[2];
var thirdClass3 = fullClass3[4];
$(".variant-list:first-of-type").attr("id", "pkVarSelected");
$(".variant-list:nth-of-type(2)").attr("id", "pkVarSelected2");
$(".variant-list:first-of-type .hidden-split-parameter").addClass("pkParametr1");
$(".variant-list:nth-of-type(2) .hidden-split-parameter").addClass("pkParametr2");
$(".variant-list:nth-of-type(3) .hidden-split-parameter").addClass("pkParametr3");
document.getElementById("pkVarSelected").addEventListener("change", pk3Function);
function pk3Function() {
if($("body.pkVarSelected").length) {
pk3Function2();
}}
document.getElementById("pkVarSelected2").addEventListener("change", pk3Function2);
function pk3Function2() {
$(".pkParametr3 .advanced-parameter-inner").css("border-bottom-left-radius","0").css("border-bottom-right-radius","0");
$(".variant-list:nth-of-type(3) .hidden-split-parameter .advanced-parameter input").each(function(pk3index) {
$("body").addClass("pkVarSelected");
$(".variant-list:first-of-type .hidden-split-parameter .advanced-parameter input").removeAttr("id","pk1Selected");
$(".variant-list:first-of-type .advanced-parameter-inner.yes-before").parent("label").children("input").attr("id","pk1Selected");
$(".variant-list:nth-of-type(2) .hidden-split-parameter .advanced-parameter input").removeAttr("id","pk2Selected");
$(".variant-list:nth-of-type(2) .advanced-parameter-inner.yes-before").parent("label").children("input").attr("id","pk2Selected");
$(".variant-list:nth-of-type(3) .hidden-split-parameter .advanced-parameter input").removeAttr("id");
var pk3Num = pk3index + 1;
var pk3Num = '.variant-list:nth-of-type(3) .hidden-split-parameter .advanced-parameter:nth-child(' + pk3Num + ') input';
pk3Num = $(this).attr("id", "pk3Selected");
var pk3p1 = $(".pkParametr1").attr("data-parameter-id");
var pk3v1 = $("#pk1Selected").attr("value");
var pk3p2 = $(".pkParametr2").attr("data-parameter-id");
var pk3v2 = $("#pk2Selected").attr("value");
var pk3p3 = $(".pkParametr3").attr("data-parameter-id");
var pk3v3 = $("#pk3Selected").attr("value");
if (pk3p1 == firstClass3) {
var pk3Final1 = pk3p1 + "-" + pk3v1;
}
if (pk3p1 == secondClass3) {
var pk3Final2 = pk3p1 + "-" + pk3v1;
}
if (pk3p1 == thirdClass3) {
var pk3Final3 = pk3p1 + "-" + pk3v1;
}
if (pk3p2 == firstClass3) {
var pk3Final1 = pk3p2 + "-" + pk3v2;
}
if (pk3p2 == secondClass3) {
var pk3Final2 = pk3p2 + "-" + pk3v2;
}
if (pk3p2 == thirdClass3) {
var pk3Final3 = pk3p2 + "-" + pk3v2;
}
if (pk3p3 == firstClass3) {
var pk3Final1 = pk3p3 + "-" + pk3v3;
}
if (pk3p3 == secondClass3) {
var pk3Final2 = pk3p3 + "-" + pk3v3;
}
if (pk3p3 == thirdClass3) {
var pk3Final3 = pk3p3 + "-" + pk3v3;
}
var Final3Variant = ".availability-value .parameter-dependent." + pk3Final1 + "-" + pk3Final2 + "-" + pk3Final3 + " .availability-label";
var pk3Var = pk3index + 1;
var pk3Var = "<div class='pkVar pkVariants" + pk3Var + "'></div>";
var pk3VarD = pk3index + 1;
var pk3VarD = ".pkVariants" + pk3VarD;
$(pk3VarD).remove();
$(this).parent().append(pk3Var);
$(Final3Variant).clone().appendTo(pk3VarD);
})
$(".advanced-parameter").removeClass("pkVarNotExist");
if( $('.advanced-parameter .pkVar').is(':empty') ) {
    $(".advanced-parameter .pkVar:empty").parent().addClass("pkVarNotExist");
    $(".advanced-parameter .pkVar:empty").html("neexistuje").css("color","#920304").css("text-align","center");
}}}


/*$('#filters').append('<div class="filtration"><span class="filtarcevice">Filtrovat více parametrů</span></div>');
$('#category-filter-hover').removeClass('visible');
$('.filtarcevice').on('click', function(){
  $(this).toggleClass('newtext');
  $('.newtext').text('Filtrovat méně parametrů')
  $('#category-filter-hover').toggleClass('visible');
});

$('#category-filter-hover .filter-section div').each(function(){
  var findlabel = $(this).find('label.active');
  if($(findlabel).length){
    $('#category-filter-hover').addClass('visible');
    $('.filtarcevice').hide();
  }
})*/

$('<span>V případě dotazů či poznámky k objednávce napište na <a href="mailto:info@povlecemevas.cz">info@povlecemevas.cz</a> do předmětu uveďte číslo objednávky. Děkujeme tým PovlečemeVás.cz</a>').insertAfter('label[for*="add-note"]');
$('.descriptiotop').insertAfter('.category-title');
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
$('.descriptiotop').insertAfter('.category-title');
//$('.filter-sections').append('<span class="filtarcevice">Filtrovat více parametrů</span>');
/*$('#category-filter-hover').removeClass('visible');
$('.filtarcevice').on('click', function(){
  $(this).hide();
  $('#category-filter-hover').addClass('visible');
});
$('#category-filter-hover .filter-section div').each(function(){
  var findlabel = $(this).find('label.active');
  if($(findlabel).length){
    $('#category-filter-hover').addClass('visible');
    $('.filtarcevice').hide();
  }
})*/
});
document.addEventListener('ShoptetPagePaginationUsed', function() {
$('.descriptiotop').insertAfter('.category-title');
/*$('.filter-sections').append('<span class="filtarcevice">Filtrovat více parametrů</span>');
$('#category-filter-hover').removeClass('visible');
$('.filtarcevice').on('click', function(){
  $(this).hide();
  $('#category-filter-hover').addClass('visible');
});
$('#category-filter-hover .filter-section div').each(function(){
  var findlabel = $(this).find('label.active');
  if($(findlabel).length){
    $('#category-filter-hover').addClass('visible');
    $('.filtarcevice').hide();
  }
})*/
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
$('.descriptiotop').insertAfter('.category-title');
/*$('.filter-sections').append('<span class="filtarcevice">Filtrovat více parametrů</span>');
$('#category-filter-hover').removeClass('visible');
$('.filtarcevice').on('click', function(){
  $(this).hide();
  $('#category-filter-hover').addClass('visible');
});
$('#category-filter-hover .filter-section div').each(function(){
  var findlabel = $(this).find('label.active');
  if($(findlabel).length){
    $('#category-filter-hover').addClass('visible');
    $('.filtarcevice').hide();
  }
})*/
});

if($('.descriptiotop').length){
  var findheight = $('.descriptiotop').height();
  console.log(findheight)
  if(findheight>50){
    $('.descriptiotop').addClass('maxheight')
    $('<div class="text-center textorder"><span class="showtext">'+textvice+'</span></div>').insertAfter('.descriptiotop').addClass('maxheight');
    $('.showtext').on("click", function(){
        $('.descriptiotop').removeClass('maxheight');
        $('.showtext').hide();
    })
  }
}


//
if($('.box-filters').length){
  $('.box-filters').insertBefore('#category-header');
  function mhfilter(){
    $('.filter-section').each(function(){

      var findopenFilter = $(this).find('.filter-label.active');
      if($(findopenFilter).length){
         console.log("mám to")
      $('div#category-filter-hover').addClass('zobraz');
    }
    })
    $('#filters').append('<div class="filtration"><span class="filtarcevice"></span></div>');
    $('#category-filter-hover').appendTo('#filters')
  $('#category-filter-hover').removeClass('visible');
  $('.filtarcevice').on('click', function(){
    $('#category-filter-hover').toggleClass('visible');
  });


}
  mhfilter();
  

  document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mhfilter();
  });
}

if($('.mobile .filters-wrapper').length){
  function mhfilter(){
    $('.filter-section').each(function(){
      var findopenFilter = $(this).find('.filter-label.active');
      if($(findopenFilter).length){
      $('#category-filter-hover').addClass('zobraz');
    }
    })
    $('#filters').append('<div class="filtration"><span class="filtarcevice"></span></div>');
    $('#category-filter-hover').appendTo('#filters')
  $('#category-filter-hover').removeClass('visible');
  $('.filtarcevice').on('click', function(){
    $('#category-filter-hover').toggleClass('visible');
  });


}
  mhfilter();
  

  document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mhfilter();
  });
}

$(window).on("load", function(){
    if($('#fvStudio-component-topproduct').length){
        $('#fvStudio-component-topproduct').each(function(){
            var findcircle = $(this).find('.fvsctp-discount-circle')
            var findfvsctptodayprice = $(this).find('.fvsctp-text_additional')
            $(findcircle).insertAfter(findfvsctptodayprice)
            
        })
 
    }
  

})


function mh_banner(){
  var url = location.pathname
  var url = '/'+url.split('/')[1]+'/'
  var kategorie = vlastni_banner[0].kategorie
  for (var k = 0; k <= kategorie.length - 1; k++){
    if(kategorie[k].url_kategorie === url){
      for (var l = 0; l <= kategorie[k].banner.length - 1; l++){
        var url_banneru = kategorie[k].banner[l].url_banneru
        var odkaz = kategorie[k].banner[l].odkaz_banneru
        if($('.banner-first').length<1){
          $('.products .product').eq(3).after('<div class="product" style="padding:0;"><a href="'+odkaz+'"><img src="'+url_banneru+'" class="banner-first"></a></div>')
        }
        if($('.banner-second').length<1){
          $('.products .product').eq(7).after('<div class="product" style="padding:0;"><a href="'+odkaz+'"><img src="'+url_banneru+'" class="banner-second"></a></div>')
        }
      }
    }
    else{
          var odkaz = vlastni_banner[0].odkaz_banneru
          if($('.banner-first').length<1){
            $('.products .product').eq(3).after('<div class="product" style="padding:0;"><a href="'+odkaz+'"><img src="'+vlastni_banner[0].univerzalni_banner+'" class="banner-first"></a></div>')
          }
          if($('.banner-second').length<1){
            $('.products .product').eq(7).after('<div class="product" style="padding:0;"><a href="'+odkaz+'"><img src="'+vlastni_banner[0].univerzalni_banner+'" class="banner-second"></a></div>')
          }
        
    }
 }
}

if($('.type-category').length){
  $(document).ready(function(){
    mh_banner()
  })
  document.addEventListener("ShoptetDOMContentLoaded", function () {
    mh_banner()
  });
}


$('.in-index .products-block:not(.pk-products-block)').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1480,
        settings: {
          slidesToShow: 3,
            slidesToScroll: 1,
        }
      },
  {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
            slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
            slidesToScroll: 1,
        }
      },
      {
        breakpoint: 570,
        settings: {
          slidesToShow: 1,
            slidesToScroll: 1,
        }
      }
    ]
  });